<template>
  <main id="main-content">
    <HomeHero />
    <HomeTrustBar />
    <HomeAssortiment />
    <HomeFeaturedBundle />
    <HomeUsps />
    <HomeSpotlight />
    <HomeReviews />
    <HomeCtaBanner />
  </main>
</template>

<script setup>
import HomeHero           from '@components/HomeHero.vue'
import HomeTrustBar       from '@components/HomeTrustBar.vue'
import HomeAssortiment    from '@components/HomeAssortiment.vue'
import HomeFeaturedBundle from '@components/HomeFeaturedBundle.vue'
import HomeUsps           from '@components/HomeUsps.vue'
import HomeSpotlight      from '@components/HomeSpotlight.vue'
import HomeReviews        from '@components/HomeReviews.vue'
import HomeCtaBanner      from '@components/HomeCtaBanner.vue'
</script>